(function () {
	function preloadCollectionTabsImage(img) {
		if (!img) {
			return Promise.resolve();
		}

		if (img.complete && img.naturalWidth > 0) {
			return Promise.resolve();
		}

		return new Promise((resolve) => {
			const preloadImage = new Image();

			preloadImage.onload = resolve;
			preloadImage.onerror = resolve;

			if (img.sizes) {
				preloadImage.sizes = img.sizes;
			}

			if (img.srcset) {
				preloadImage.srcset = img.srcset;
			}

			preloadImage.src = img.currentSrc || img.src;
		});
	}

	function preloadCollectionTabsImages(container) {
		const images = Array.from(container.querySelectorAll('.collection-list img')).filter((img) => {
			return img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset');
		});

		if (!images.length) {
			return Promise.resolve();
		}

		return Promise.all(images.map((img) => preloadCollectionTabsImage(img)));
	}

	function initializeCollectionTabsReveal(container) {
		if (!container) {
			container = document.querySelector('.collection-list-wrapper');
		}
		if (!container) {
			return;
		}

		const tabs = container.querySelectorAll('.collection-tabs-container');

		if (!tabs.length) {
			return;
		}

		tabs.forEach((tab) => {
			const revealToken = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
			tab.dataset.gridRevealToken = revealToken;

			if (!tab.classList.contains('loading')) {
				tab.classList.add('loading', 'loading-images');
			}

			preloadCollectionTabsImages(tab).then(() => {
				requestAnimationFrame(() => {
					if (tab.dataset.gridRevealToken !== revealToken) {
						return;
					}

					tab.classList.remove('loading', 'loading-images');
				});
			});
		});
	}

	function collectionTabs() {
		const collectionsTabs = document.querySelectorAll(".collection-tabs");

		if (collectionsTabs.length) {
			collectionsTabs.forEach(tabs => {
				const id = tabs.dataset.sectionId;
        const collectionTabsElement = document.getElementById(`shopify-section-${id}`);
        const collectionTabs = collectionTabsElement.querySelector('.collection-tabs');

        if (!collectionTabs) return;

        const collectionTabsWidth = window.innerWidth;
        const collectionTabsNavigation = collectionTabs.querySelectorAll('.navigation-item');
        const collectionTabsList = collectionTabs.querySelectorAll('.collection-tabs-list');
        const collectionTabsContainers = collectionTabs.querySelectorAll('.collection-tabs-container');

        const activateTab = (item) => {
          collectionTabsNavigation.forEach((element) => element.classList.remove('active'));
          item.classList.add('active');
 
          collectionTabsList.forEach((element) => element.classList.remove('active'));
          collectionTabsContainers.forEach((element) => element.classList.remove('active'));

          const tabId = item.dataset.tab;
          const activeList = collectionTabs.querySelector(`[data-tab-id="${tabId}"]`);
          activeList.classList.add('active');
          
          // Find the parent container and add active class
          const activeContainer = activeList.closest('.collection-tabs-container');
          if (activeContainer) {
            activeContainer.classList.add('active');
            // Re-initialize image preloading for this tab
            initializeCollectionTabsReveal(collectionTabsElement.querySelector('.collection-list-wrapper'));
          }
        };

        collectionTabsNavigation.forEach((item) => {
          item.addEventListener("click", () => activateTab(item));
        });

        if (collectionTabsWidth >= 1025) {
          collectionTabsNavigation.forEach((item) => {
            item.addEventListener("keyup", (event) => (event.key === "Enter" || event.key === "Space") && activateTab(item));
          });
        }
        
        // Initialize image preloading
        initializeCollectionTabsReveal(collectionTabsElement.querySelector('.collection-list-wrapper'));
      });
    }
  }

  document.addEventListener('DOMContentLoaded', collectionTabs);
  document.addEventListener('shopify:section:load', collectionTabs);
  window.addEventListener('resize', collectionTabs);

  collectionTabs();
})();